import e, { isAxiosError as t } from "axios";
import { useMemo as n } from "react";
// ../backend-config/dist/index.js
var r = Object.fromEntries([
	"prod",
	"stag",
	"stag2",
	"dev1",
	"preprod"
].map((e) => [e, e === "prod" ? "dixa.io" : `euw1.${e}.dixa.io`]));
function i(e) {
	return new Set(Object.values(r)).has(e);
}
function a(e) {
	if (!e) return "prod";
	for (let [t, n] of Object.entries(r)) if (e === n) return t;
	return "prod";
}
function o(e) {
	e = e.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	let t = RegExp(`[\\?&]${e}=([^&#]*)`).exec(location.search);
	return t === null ? null : s(t[1].replace(/\+/g, " "));
}
function s(e) {
	try {
		return decodeURIComponent(e);
	} catch {
		return console.warn(`Failed to decode param value '${e}'`), e;
	}
}
var c = { backendDomain: "dixa:backend-domain" };
function l() {
	let e = o("staging") || o("backend-domain");
	if (e) {
		let t = /^\d+$/.test(e) ? `euw1.stag${e === "1" ? "" : e}.dixa.io` : e;
		return i(t) ? (d(t), t) : null;
	}
	return null;
}
function u() {
	let e = document.cookie.split("; ").find((e) => e.startsWith(`${c.backendDomain}=`)), t = e ? decodeURIComponent(e.split("=")[1]) : null;
	return t && !i(t) ? (ee(), null) : t;
}
function d(e) {
	document.cookie = `${c.backendDomain}=${encodeURIComponent(e)}; path=/; max-age=31536000; SameSite=Lax`;
}
function ee() {
	document.cookie = `${c.backendDomain}=; path=/; max-age=0`;
}
var f = window.location.origin.replace(/^https?:\/\//, ""), p = l() ?? u(), m = a(p), h = {
	develop: [
		"localhost:8080",
		"dixadev.com",
		"dixa.io"
	],
	test: {
		security: ["dixa-security.com", "dixa-security.net"],
		automation: [
			"localhost:9999",
			"test-agent-interface.dixa.io",
			"test.dixatest.com",
			"okta-test-org.dixatest.com"
		]
	},
	custom: [
		"thehaddaway.dixa.com",
		"demo.dixa.com",
		"developer.dixa.com",
		"okta-test.dixa.com",
		"development.dixa.com",
		"engineering.dixa.com"
	],
	default: {
		email: "dixa.com",
		emailIntegration: "email.dixa.io",
		integrations: "docs.dixa.io",
		service: "dixa.io",
		status: "status.dixa.io",
		subdomain: "demo",
		userContent: "dixausercontent.com",
		web: "dixa.com",
		accounts: "accounts.dixa.com",
		knowledge: "knowledge-backend-cdn",
		satisfactionSurveyPreview: "csat.reviews"
	}
}, te = {
	assets: `https://assets.${h.default.service}`,
	toolkit: `https://toolkit.${h.default.service}`,
	widget: `https://widget.${h.default.service}`,
	messenger: m === "prod" ? `https://messenger.${h.default.service}` : `https://messenger.${m}.${h.default.service}`,
	rest: `https://api.${p ?? h.default.service}`,
	advancedInsights: `https://api.${p ?? h.default.service}/v1/advanced-insights/`,
	partnerIntegrations: `https://partner-integrations.${p ?? h.default.service}`,
	files: `https://files.${p ?? h.default.service}`,
	webSocket: `wss://agent-sockets.${p ?? h.default.service}/v2/agent/`,
	userContent: p ? `https://raw.${p.replace(h.default.service, h.default.userContent)}` : `https://raw.${h.default.userContent}`,
	signUp: `https://${h.default.accounts}/signup`,
	logIn: `https://${h.default.accounts}/signin`,
	knowledgeCdn: m === "prod" ? `https://knowledge-backend-cdn.${h.default.service}` : `https://knowledge-backend-cdn.${m}.${h.default.service}`,
	knowledgeApi: `https://knowledge-backend.${p ?? h.default.service}`,
	satisfactionSurveyPreview: m === "prod" ? `https://${h.default.satisfactionSurveyPreview}/preview.html` : `https://stag.${h.default.satisfactionSurveyPreview}/preview.html`
}, ne = {
	amplitude: { environment: [
		...h.test.automation,
		...h.develop,
		...h.test.security,
		...h.custom
	].includes(f) || m !== "prod" ? "stag" : "prod" },
	launchDarkly: h.develop.includes(f) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
	launchDarklyBackend: h.develop.includes(f) ? "6058545ab95b560e51acf129" : "6058545ab95b560e51acf12a",
	launchDarklyMiuros: h.develop.includes(f) ? "649ea8d43e6eca13a145c21f" : "649ea8d43e6eca13a145c220",
	stripe: h.develop.includes(f) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
	elevio: "599d54aacd7bd",
	birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
	jabra: {
		partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
		appId: "Dixa",
		appName: "Dixa"
	},
	messenger: { token: {
		prod: h.develop.includes(f) ? "95b2b555c0b046a18e5d508837811008" : "7c08132d4bf5d5f1bf4432133ef8254e3262f9ef",
		stag: "0a76a5650f3540dc8bad030e54aa2e22",
		stag2: "0a76a5650f3540dc8bad030e54aa2e22",
		dev1: "414a01b7802f4d4bb61a6ab6aaacd442",
		preprod: ""
	} }
}, g = {
	environment: m,
	domain: h.default,
	sdk: ne,
	url: te,
	backendDomain: p
}, _ = new class {
	isElectron() {
		return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
	}
	async getVersion() {
		return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
	}
	async isStandaloneBuild() {
		return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
	}
	async isMsiBuild() {
		return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
	}
}();
// ../semver/dist/index.js
function re(e, t) {
	return ie(e), ie(t), e.localeCompare(t, void 0, { numeric: !0 });
}
function ie(e) {
	if (e.split(".").length !== 3) throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
// ../../../node_modules/@sentry/core/build/esm/debug-build.js
var v = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, y = globalThis, ae = "10.75.3";
// ../../../node_modules/@sentry/core/build/esm/carrier.js
function b() {
	return x(y), y;
}
function x(e) {
	let t = e.__SENTRY__ = e.__SENTRY__ || {};
	return t.version = t.version || "10.75.3", t[ae] = t["10.75.3"] || {};
}
function S(e, t, n = y) {
	let r = n.__SENTRY__ = n.__SENTRY__ || {}, i = r[ae] = r["10.75.3"] || {};
	return i[e] || (i[e] = t());
}
// ../../../node_modules/@sentry/core/build/esm/utils/debug-logger.js
var oe = "Sentry Logger ", se = {};
function ce(e) {
	if (!("console" in y)) return e();
	let t = y.console, n = {}, r = Object.keys(se);
	r.forEach((e) => {
		let r = se[e];
		n[e] = t[e], t[e] = r;
	});
	try {
		return e();
	} finally {
		r.forEach((e) => {
			t[e] = n[e];
		});
	}
}
function le() {
	T().enabled = !0;
}
function ue() {
	T().enabled = !1;
}
function C() {
	return T().enabled;
}
function de(...e) {
	w("log", ...e);
}
function fe(...e) {
	w("warn", ...e);
}
function pe(...e) {
	w("error", ...e);
}
function w(e, ...t) {
	v && C() && ce(() => {
		y.console[e](`${oe}[${e}]:`, ...t);
	});
}
function T() {
	return v ? S("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
var E = {
	enable: le,
	disable: ue,
	isEnabled: C,
	log: de,
	warn: fe,
	error: pe
}, me = Object.prototype.toString;
function he(e, t) {
	return me.call(e) === `[object ${t}]`;
}
function ge(e) {
	return he(e, "Object");
}
function _e(e) {
	return !!(e?.then && typeof e.then == "function");
}
// ../../../node_modules/@sentry/core/build/esm/utils/object.js
function ve(e, t, n) {
	try {
		Object.defineProperty(e, t, {
			value: n,
			writable: !0,
			configurable: !0
		});
	} catch {
		v && E.log(`Failed to add non-enumerable property "${String(t)}" to object`, e);
	}
}
// ../../../node_modules/@sentry/core/build/esm/utils/randomSafeContext.js
var D;
function O(e) {
	if (D !== void 0) return D ? D(e) : e();
	let t = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__"), n = y;
	return t in n && typeof n[t] == "function" ? (D = n[t], D(e)) : (D = null, e());
}
function k() {
	return O(() => Math.random());
}
function ye() {
	return O(() => Date.now());
}
// ../../../node_modules/@sentry/core/build/esm/utils/string.js
function be(e, t = 0) {
	return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
// ../../../node_modules/@sentry/core/build/esm/utils/misc.js
function xe() {
	let e = y;
	return e.crypto || e.msCrypto;
}
var A;
function Se() {
	return k() * 16;
}
function j(e = xe()) {
	try {
		if (e?.randomUUID) return O(() => e.randomUUID()).replace(/-/g, "");
	} catch {}
	return A ||= "10000000100040008000100000000000", A.replace(/[018]/g, (e) => (e ^ (Se() & 15) >> e / 4).toString(16));
}
// ../../../node_modules/@sentry/core/build/esm/utils/time.js
var M = 1e3;
function N() {
	return ye() / M;
}
function Ce() {
	let { performance: e } = y;
	if (!e?.now || !e.timeOrigin) return N;
	let t = e.timeOrigin;
	return () => (t + O(() => e.now())) / M;
}
var we;
function Te() {
	return (we ??= Ce())();
}
// ../../../node_modules/@sentry/core/build/esm/session.js
function Ee(e, t = {}) {
	if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Te(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : j()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration) e.duration = void 0;
	else if (typeof t.duration == "number") e.duration = t.duration;
	else {
		let t = e.timestamp - e.started;
		e.duration = t >= 0 ? t : 0;
	}
	t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
// ../../../node_modules/@sentry/core/build/esm/utils/merge.js
function P(e, t, n = 2) {
	if (!t || typeof t != "object" || n <= 0) return t;
	if (e && Object.keys(t).length === 0) return e;
	let r = { ...e };
	for (let e in t) Object.prototype.hasOwnProperty.call(t, e) && (r[e] = P(r[e], t[e], n - 1));
	return r;
}
// ../../../node_modules/@sentry/core/build/esm/utils/propagationContext.js
function F() {
	return j();
}
// ../../../node_modules/@sentry/core/build/esm/utils/weakRef.js
function De(e) {
	try {
		let t = y.WeakRef;
		if (typeof t == "function") return new t(e);
	} catch {}
	return e;
}
function Oe(e) {
	if (e) {
		if (typeof e == "object" && "deref" in e && typeof e.deref == "function") try {
			return e.deref();
		} catch {
			return;
		}
		return e;
	}
}
// ../../../node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var I = "_sentrySpan";
function L(e, t) {
	t ? ve(e, I, De(t)) : delete e[I];
}
function R(e) {
	return Oe(e[I]);
}
// ../../../node_modules/@sentry/core/build/esm/scope.js
var ke = 100, z = class e {
	constructor() {
		this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._attributes = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
			traceId: F(),
			sampleRand: k()
		};
	}
	clone() {
		let t = new e();
		return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._attributes = { ...this._attributes }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = { values: [...this._contexts.flags.values] }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, t._conversationId = this._conversationId, L(t, R(this)), t;
	}
	setClient(e) {
		this._client = e;
	}
	setLastEventId(e) {
		this._lastEventId = e;
	}
	getClient() {
		return this._client;
	}
	lastEventId() {
		return this._lastEventId;
	}
	addScopeListener(e) {
		this._scopeListeners.push(e);
	}
	addEventProcessor(e) {
		return this._eventProcessors.push(e), this;
	}
	setUser(e) {
		return this._user = e || {
			email: void 0,
			id: void 0,
			ip_address: void 0,
			username: void 0
		}, this._session && Ee(this._session, { user: e }), this._notifyScopeListeners(), this;
	}
	getUser() {
		return this._user;
	}
	setConversationId(e) {
		return this._conversationId = e || void 0, this._notifyScopeListeners(), this;
	}
	setTags(e) {
		return this._tags = {
			...this._tags,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setTag(e, t) {
		return this.setTags({ [e]: t });
	}
	setAttributes(e) {
		return this._attributes = {
			...this._attributes,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setAttribute(e, t) {
		return this.setAttributes({ [e]: t });
	}
	removeAttribute(e) {
		return e in this._attributes && (delete this._attributes[e], this._notifyScopeListeners()), this;
	}
	setExtras(e) {
		return this._extra = {
			...this._extra,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setExtra(e, t) {
		return this._extra = {
			...this._extra,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setFingerprint(e) {
		return this._fingerprint = e, this._notifyScopeListeners(), this;
	}
	setLevel(e) {
		return this._level = e, this._notifyScopeListeners(), this;
	}
	setTransactionName(e) {
		return this._transactionName = e, this._notifyScopeListeners(), this;
	}
	setContext(e, t) {
		return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
	}
	setSession(e) {
		return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
	}
	getSession() {
		return this._session;
	}
	update(t) {
		if (!t) return this;
		let n = typeof t == "function" ? t(this) : t, { tags: r, attributes: i, extra: a, user: o, contexts: s, level: c, fingerprint: l = [], propagationContext: u, conversationId: d } = (n instanceof e ? n.getScopeData() : ge(n) ? t : void 0) || {};
		return this._tags = {
			...this._tags,
			...r
		}, this._attributes = {
			...this._attributes,
			...i
		}, this._extra = {
			...this._extra,
			...a
		}, this._contexts = {
			...this._contexts,
			...s
		}, o && Object.keys(o).length && (this._user = o), c && (this._level = c), l.length && (this._fingerprint = l), u && (this._propagationContext = u), d && (this._conversationId = d), this;
	}
	clear() {
		return this._breadcrumbs = [], this._tags = {}, this._attributes = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, this._conversationId = void 0, L(this, void 0), this._attachments = [], this.setPropagationContext({
			traceId: F(),
			sampleRand: k()
		}), this._notifyScopeListeners(), this;
	}
	addBreadcrumb(e, t) {
		let n = typeof t == "number" ? t : ke;
		if (n <= 0) return this;
		let r = {
			timestamp: N(),
			...e,
			message: e.message ? be(e.message, 2048) : e.message
		};
		return this._breadcrumbs.push(r), this._breadcrumbs.length > n && (this._breadcrumbs = this._breadcrumbs.slice(-n), this._client?.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
	}
	getLastBreadcrumb() {
		return this._breadcrumbs[this._breadcrumbs.length - 1];
	}
	clearBreadcrumbs() {
		return this._breadcrumbs = [], this._notifyScopeListeners(), this;
	}
	addAttachment(e) {
		return this._attachments.push(e), this;
	}
	clearAttachments() {
		return this._attachments = [], this;
	}
	getScopeData() {
		return {
			breadcrumbs: this._breadcrumbs,
			attachments: this._attachments,
			contexts: this._contexts,
			tags: this._tags,
			attributes: this._attributes,
			extra: this._extra,
			user: this._user,
			level: this._level,
			fingerprint: this._fingerprint || [],
			eventProcessors: this._eventProcessors,
			propagationContext: this._propagationContext,
			sdkProcessingMetadata: this._sdkProcessingMetadata,
			transactionName: this._transactionName,
			span: R(this),
			conversationId: this._conversationId
		};
	}
	setSDKProcessingMetadata(e) {
		return this._sdkProcessingMetadata = P(this._sdkProcessingMetadata, e, 2), this;
	}
	setPropagationContext(e) {
		return this._propagationContext = e, this;
	}
	getPropagationContext() {
		return this._propagationContext;
	}
	captureException(e, t) {
		let n = t?.event_id || j();
		if (!this._client) return v && E.warn("No client configured on scope - will not capture exception!"), n;
		let r = /* @__PURE__ */ Error("Sentry syntheticException");
		return this._client.captureException(e, {
			originalException: e,
			syntheticException: r,
			...t,
			event_id: n
		}, this), n;
	}
	captureMessage(e, t, n) {
		let r = n?.event_id || j();
		if (!this._client) return v && E.warn("No client configured on scope - will not capture message!"), r;
		let i = n?.syntheticException ?? Error(e);
		return this._client.captureMessage(e, t, {
			originalException: e,
			syntheticException: i,
			...n,
			event_id: r
		}, this), r;
	}
	captureEvent(e, t) {
		let n = e.event_id || t?.event_id || j();
		return this._client ? (this._client.captureEvent(e, {
			...t,
			event_id: n
		}, this), n) : (v && E.warn("No client configured on scope - will not capture event!"), n);
	}
	_notifyScopeListeners() {
		this._notifyingListeners ||= (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
			e(this);
		}), !1);
	}
};
// ../../../node_modules/@sentry/core/build/esm/defaultScopes.js
function Ae() {
	return S("defaultCurrentScope", () => new z());
}
function je() {
	return S("defaultIsolationScope", () => new z());
}
// ../../../node_modules/@sentry/core/build/esm/utils/chain-and-copy-promiselike.js
var B = (e) => e instanceof Promise && !e[V], V = /* @__PURE__ */ Symbol("chained PromiseLike"), Me = (e, t, n) => {
	let r = e.then((e) => (t(e), e), (e) => {
		throw n(e), e;
	});
	return B(r) && B(e) ? r : Ne(e, r);
}, Ne = (e, t) => {
	if (!t) return e;
	let n = !1;
	for (let r in e) {
		if (r in t) continue;
		n = !0;
		let i = e[r];
		typeof i == "function" ? Object.defineProperty(t, r, {
			value: (...t) => i.apply(e, t),
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : t[r] = i;
	}
	return n && Object.assign(t, { [V]: !0 }), t;
}, Pe = class {
	constructor(e, t) {
		let n;
		n = e || new z();
		let r;
		r = t || new z(), this._stack = [{ scope: n }], this._isolationScope = r;
	}
	withScope(e) {
		let t = this._pushScope(), n;
		try {
			n = e(t);
		} catch (e) {
			throw this._popScope(), e;
		}
		return _e(n) ? Me(n, () => this._popScope(), () => this._popScope()) : (this._popScope(), n);
	}
	getClient() {
		return this.getStackTop().client;
	}
	getScope() {
		return this.getStackTop().scope;
	}
	getIsolationScope() {
		return this._isolationScope;
	}
	getStackTop() {
		return this._stack[this._stack.length - 1];
	}
	_pushScope() {
		let e = this.getScope().clone();
		return this._stack.push({
			client: this.getClient(),
			scope: e
		}), e;
	}
	_popScope() {
		return this._stack.length <= 1 ? !1 : !!this._stack.pop();
	}
};
function H() {
	let e = x(b());
	return e.stack = e.stack || new Pe(Ae(), je());
}
function Fe(e) {
	return H().withScope(e);
}
function Ie(e, t) {
	let n = H();
	return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function Le(e) {
	return H().withScope(() => e(H().getIsolationScope()));
}
function Re() {
	return {
		withIsolationScope: Le,
		withScope: Fe,
		withSetScope: Ie,
		withSetIsolationScope: (e, t) => Le(t),
		getCurrentScope: () => H().getScope(),
		getIsolationScope: () => H().getIsolationScope()
	};
}
// ../../../node_modules/@sentry/core/build/esm/asyncContext/index.js
function ze(e) {
	let t = x(e);
	return t.acs ? t.acs : Re();
}
// ../../../node_modules/@sentry/core/build/esm/currentScopes.js
function U() {
	return ze(b()).getCurrentScope();
}
function Be() {
	return ze(b()).getIsolationScope();
}
function Ve() {
	return U().getClient();
}
// ../../../node_modules/@sentry/core/build/esm/utils/prepareEvent.js
function He(e) {
	if (e) return Ue(e) || Ge(e) ? { captureContext: e } : e;
}
function Ue(e) {
	return e instanceof z || typeof e == "function";
}
var We = [
	"user",
	"level",
	"extra",
	"contexts",
	"tags",
	"fingerprint",
	"propagationContext"
];
function Ge(e) {
	return Object.keys(e).some((e) => We.includes(e));
}
// ../../../node_modules/@sentry/core/build/esm/exports.js
function Ke(e, t) {
	return U().captureException(e, He(t));
}
function qe(e, t) {
	let n = typeof t == "string" ? t : void 0, r = typeof t == "string" ? void 0 : { captureContext: t };
	return U().captureMessage(e, n, r);
}
function Je(e, t) {
	Be().setContext(e, t);
}
// ../../../node_modules/@sentry/core/build/esm/breadcrumbs.js
var Ye = 100;
function W(e, t) {
	let n = Ve(), r = Be();
	if (!n) return;
	let { beforeBreadcrumb: i = null, maxBreadcrumbs: a = Ye } = n.getOptions();
	if (a <= 0) return;
	let o = {
		timestamp: N(),
		...e
	}, s = i ? ce(() => i(o, t)) : o;
	s !== null && (n.emit && n.emit("beforeAddBreadcrumb", s, t), r.addBreadcrumb(s, a));
}
// ../sentry/dist/index.js
var G;
(function(e) {
	e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation", e.Knowledge = "knowledge";
})(G ||= {});
// ../auth/dist/jwt/jwt.js
function K(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(Buffer.from(n, "base64").toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
// ../auth/dist/redirect/redirect.js
var Xe = g.backendDomain ? { "backend-domain": g.backendDomain } : void 0;
function q() {
	let e = new URLSearchParams({
		noToken: "true",
		...Xe
	}).toString();
	document.location.href = `${g.url.logIn}?${e}`;
}
// ../auth/dist/authManager/authStorageConfig.js
var J = "authData", Ze = 600, Qe = 5, Y = new class {
	authData = null;
	accessTokenExpiresAt = 0;
	clientServerTimeDiff = 0;
	estimatedServerTime() {
		let e = Date.now() / 1e3;
		return this.clientServerTimeDiff >= Qe || this.clientServerTimeDiff <= -5 ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
	}
	setAuthData(e) {
		this.authData = e;
		let t = Math.ceil(Date.now() / 1e3) + Ze, n = K(e.access_token).exp;
		if (this.clientServerTimeDiff = n - t, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Qe) {
			let e = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
			console.info(`Client time is ${e} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
		}
		this.accessTokenExpiresAt = n, localStorage.setItem(J, JSON.stringify(e));
	}
	getAuthData() {
		if (this.authData) return this.authData;
		let e = localStorage.getItem(J), t = e ? JSON.parse(e) : null;
		return this.validateAuthDataComplete(t) && (this.authData = t), t;
	}
	removeAuthData() {
		this.authData = null, localStorage.removeItem(J);
	}
	getAccessToken() {
		return this.authData?.access_token || null;
	}
	getRefreshToken() {
		return this.authData?.refresh_token || null;
	}
	validateAuthDataComplete(e) {
		return e ? [
			"access_token",
			"refresh_token",
			"expires_in"
		].every((t) => e[t] !== void 0) : !1;
	}
	isAccessTokenExpired() {
		if (!this.getAccessToken()) return !0;
		let e = this.accessTokenExpiresAt - 30;
		return this.estimatedServerTime() >= e;
	}
	isRefreshTokenExpired(e) {
		if (!e) return !0;
		let t = K(e), n = t.exp - 30;
		return !t || this.estimatedServerTime() >= n;
	}
	accessTokenExpiresInMs() {
		return (this.accessTokenExpiresAt - 30 - this.estimatedServerTime()) * 1e3;
	}
}();
// ../auth/dist/authManager/interceptor.js
async function $e(e) {
	let t = window.location.origin.replace(/^https?:\/\//, "");
	if (e.response && !["localhost:8080", "uptrends-monitor"].some((e) => t.includes(e))) {
		try {
			let t = e.response.config.headers.Authorization ?? "", n = t ? t.toString()?.split("Basic ")[1] : "", r = n ? atob(n).split("token:")[1] : "", i = r ? K(r).exp : "None", a = await Q.getAuthData({ localStorageOnly: !0 }), o = Math.floor(Date.now() / 1e3), s = a?.access_token, c = a?.refresh_token, l = s ? K(s).exp : "None", u = c ? K(c).exp : "None", d = typeof i == "number" ? o - i : "Unknown", ee = typeof l == "number" ? o - l : "Unknown", f = typeof u == "number" ? o - u : "Unknown", p = e.response.headers["x-dixa-rid"];
			Je("Expires", {
				currentTimestamp: o,
				accessTokenFromHeader: i,
				accessTokenFromHeaderDiff: d,
				accessTokenFromLocalStorage: l,
				accessTokenFromLocalStorageDiff: ee,
				refreshTokenFromLocalStorage: u,
				refreshTokenFromLocalStorageDiff: f,
				xDixaRid: p,
				navigatorOnline: navigator.onLine
			});
		} catch (e) {
			console.error("Error adding Sentry error context", e);
		}
		qe("401 unauthorized interceptor", {
			level: "debug",
			tags: {
				team: G.Platform,
				domain: t
			}
		});
	}
}
var X = /* @__PURE__ */ new Map(), et = 3;
function tt(e) {
	e.interceptors.response.use((e) => (X.delete(e.config.url), e), (t) => {
		if (t.response) {
			let { status: n } = t.response;
			switch (n) {
				case st.Unauthorized:
					if (!Q.isRefreshTokenExpired() && t.config) {
						W({
							category: "errorInterceptor",
							message: "Access token expired after request",
							level: "debug"
						});
						let n = X.get(t.config.url) ?? 0;
						if (console.log(`Retrying request (${n + 1}): ${t.config.url}`), n <= et) return X.set(t.config.url, n + 1), e(t.config);
					}
					$e(t), console.error("401 unauthorized interceptor"), q();
			}
		}
		return Promise.reject(t);
	});
}
// ../auth/dist/authManager/authManager.js
var nt = e.create();
tt(nt);
var Z = console.log;
async function rt(e) {
	return new Promise((t) => setTimeout(t, e * 1e3));
}
var it = class extends Error {
	constructor(e, t) {
		super(e, t);
	}
};
function at(e = 0) {
	return Math.min(Math.round((Math.random() + 1) * 1.5 ** e), 30);
}
var ot = 5, Q = new class {
	authDataPromise = null;
	retryCount = 0;
	async init(e) {
		let t = await this.refresh(e);
		if (t) Y.setAuthData(t);
		else throw new it("Failed to init refresh token", { cause: Y.isRefreshTokenExpired(e) ? "expired" : "unknown" });
	}
	getDebugInfo() {
		let e = Y.getAccessToken();
		if (!e) return {};
		let { exp: t } = K(e);
		return {
			expire: t ? (/* @__PURE__ */ new Date(t * 1e3)).toISOString() : null,
			now: (/* @__PURE__ */ new Date()).toISOString()
		};
	}
	async getAuthData({ localStorageOnly: e = !1 } = {}) {
		if (e) return Y.getAuthData();
		if (this.authDataPromise) return await this.authDataPromise;
		let t = Y.getAuthData();
		return t ? Y.isAccessTokenExpired() ? (W({
			category: "refreshToken",
			message: "expired or about to expire",
			level: "debug",
			data: this.getDebugInfo()
		}), this.authDataPromise = this.refresh(t.refresh_token).then((e) => (e && Y.setAuthData(e), this.authDataPromise = null, e)), await this.authDataPromise) : t : null;
	}
	removeAuthData() {
		return Y.removeAuthData();
	}
	validateAuthDataComplete(e) {
		return Y.validateAuthDataComplete(e);
	}
	isAccessTokenExpired() {
		return Y.isAccessTokenExpired();
	}
	isRefreshTokenExpired() {
		let e = Y.getAuthData();
		return !e || Y.isRefreshTokenExpired(e.refresh_token);
	}
	async isSupported() {
		return !_.isElectron() || re(await _.getVersion(), "3.7.0") === 1;
	}
	async refresh(e, t = ot) {
		try {
			return await nt.post(`${g.url.rest}/v2/login/refresh`, { refreshToken: e }).then((e) => (this.retryCount = 0, e.data.data));
		} catch (n) {
			return await this.handleRefreshError(n, e, t);
		}
	}
	async waitUntilOnline() {
		let e = navigator.onLine === !1;
		for (e && (Z("AUTH", "Network connection offline - waiting..."), W({
			category: "refreshToken",
			message: "Network connection offline - waiting...",
			level: "debug"
		})); navigator.onLine === !1;) await rt(5);
		e && (Z("AUTH", "Network connection restored"), W({
			category: "refreshToken",
			message: "Network connection restored",
			level: "debug"
		}));
	}
	async retryRefresh(e, t) {
		await this.waitUntilOnline(), this.retryCount++;
		let n = at(this.retryCount);
		return Z("AUTH", `Retrying in ${n} seconds`), await rt(n), await this.refresh(e, t);
	}
	async handleRefreshError(e, n, r) {
		if (Y.isRefreshTokenExpired(n)) return Z("AUTH", "Refresh token expired"), W({
			category: "refreshToken",
			message: "Refresh token expired",
			level: "debug"
		}), Y.removeAuthData(), q(), null;
		if (t(e)) {
			if (e.message === "timeout exceeded") return Z("AUTH", "Timeout exceeded"), W({
				category: "refreshToken",
				message: "Timeout exceeded",
				level: "debug"
			}), await this.retryRefresh(n, r);
			if (e.message === "Network Error") return Z("AUTH", "Network error"), W({
				category: "refreshToken",
				message: "Network error",
				level: "debug"
			}), await this.retryRefresh(n, r);
			if (e.response?.status === 401) return Z("AUTH", "Refresh token invalid (401)"), Y.removeAuthData(), q(), null;
			Ke(e, {
				level: "error",
				tags: {
					team: G.Platform,
					errorSource: "authManager.refresh"
				}
			});
		}
		return r <= 0 ? (Z("AUTH", "Retries exhausted, logging out"), Ke(e, {
			level: "error",
			tags: {
				team: G.Platform,
				errorSource: "authManager.refresh"
			}
		}), Y.removeAuthData(), q(), null) : (Z("AUTH", `Retrying ${r} more times`), await this.retryRefresh(n, r - 1));
	}
	accessTokenExpiresInMs() {
		return Y.accessTokenExpiresInMs();
	}
}(), st;
(function(e) {
	e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(st ||= {});
// src/accessControl.ts
var ct = e.create(), $ = new class {
	user = null;
	scopes = null;
	_roles = null;
	get isInitialized() {
		return this.user !== null;
	}
	async init({ user: e }) {
		this.user = e;
		let t = await this.introspectAccessToken();
		t && (this.scopes = t.scope, this._roles = t.roles);
	}
	get roles() {
		return this._roles;
	}
	hasAccess(e, t) {
		if (!this.isInitialized || this.scopes === null) return !1;
		if (Array.isArray(e)) {
			let { strategy: n = "all" } = t ?? {};
			return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
		}
		return this.scopes.includes(e);
	}
	hasScope = (e) => this.scopes.includes(e);
	async introspectAccessToken() {
		let e = await Q.getAuthData({ localStorageOnly: !0 });
		if (!e) return null;
		try {
			return (await ct.post(`${g.url.rest}/v1/introspect`, { token: e.access_token }, { transformResponse: (e) => {
				let t = JSON.parse(e);
				return {
					...t,
					scope: t.scope ? t.scope.split(" ") : []
				};
			} })).data;
		} catch {
			return null;
		}
	}
	reset() {
		this.user = null, this.scopes = null, this._roles = null;
	}
}(), lt = (e, t) => n(() => $.hasAccess(e, t), []);
export { $ as accessControl, lt as useHasAccess };

//# sourceMappingURL=index.js.map